module.exports = __webpack_public_path__ + "prod/1.42.2/img/connect-two.824e0a8d.png";